import { css } from 'aphrodite';
import { Button, Header, Modal } from 'semantic-ui-react';

import stylesCommon from '../../StylesCommons';

interface ComonModalProps {
    header: React.ReactNode;
    content: React.ReactNode;
    confirmButtonLabel: string;
    cancelButtonLabel: string;
    isOpen?: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

function CommonModal(props: ComonModalProps) {
    const { header, content, confirmButtonLabel, cancelButtonLabel, isOpen, onClose, onConfirm } =
        props;

    return (
        <div className={css(stylesCommon.divWithContentWidth)}>
            <Modal open={isOpen} size="tiny">
                <Header content={header} />
                <Modal.Content>{content}</Modal.Content>
                <Modal.Actions>
                    <Button onClick={onConfirm} className={css(stylesCommon.buttonPrimary)}>
                        {confirmButtonLabel}
                    </Button>
                    <Button onClick={onClose} className={css(stylesCommon.buttonSecondary)}>
                        {cancelButtonLabel}
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
}

export default CommonModal;
